import { Action, createAction, handleActions } from 'redux-actions'

export interface ILayerAlertState {
  amount: string
  customerId: string
  fee: string
  isDisbursal: boolean
  loanAcctNo: string
  loanAmt: string
  productTypeCode: string
  reserved: string
  isOpen: boolean
  useTransition?: boolean
  acctTitle: string
  acctNo: string
}

export const BILLPAYMENT_ALERT_LAYER = 'BillPaymentAlertLayer'

const ALERT_OPEN = `${BILLPAYMENT_ALERT_LAYER}/ALERT_OPEN`
const ALERT_CLOSE = `${BILLPAYMENT_ALERT_LAYER}/ALERT_CLOSE`

export const billPaymentAlertLayerActions = {
  alertOpen: createAction(ALERT_OPEN),
  alertClose: createAction(ALERT_CLOSE),
}

const initialState = {
  amount: '',
  customerId: '',
  fee: '',
  isDisbursal: false,
  loanAcctNo: '',
  loanAmt: '',
  productTypeCode: '',
  reserved: '',
  isOpen: false,
  useTransition: false,
  acctTitle: '',
  acctNo: '',
}

const reducer = {
  [ALERT_OPEN]: (state: ILayerAlertState, action: Action<Object>) => ({
    ...state,
    isOpen: true,
    ...action.payload,
  }),
  [ALERT_CLOSE]: (state: ILayerAlertState, action: Action<Object>) => ({
    ...state,
    isOpen: false,
  }),
}

export const billpaymentAlertLayerReducer = handleActions(reducer, initialState)
